import { render, staticRenderFns } from "./gift-add.vue?vue&type=template&id=e6e93efc"
import script from "./gift-add.vue?vue&type=script&lang=js"
export * from "./gift-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports